import React from "react";
// import logo from './logo.svg';
import '../App.css';
import Header from '../landingComponents/Header';
import ContentSection from '../landingComponents/ContentSection';
import ProgramSection from '../landingComponents/ProgramSection';
import Footer from '../landingComponents/Footer';
import Navbar from '../landingComponents/Navbar';

const LandingPage=()=>{
    return(
<>
  <Navbar/>
   <Header/>
   <ContentSection/>
   <ProgramSection/>
   {/* <CartPage/> */}
   <Footer/>
</>
    );
}


export default LandingPage;